import { FC } from 'react';
import { Box, Typography } from '@mui/material';
interface GamesDetailsCardProps {
  gameData: any;
}

const GamesDetailsCard: FC<GamesDetailsCardProps> = ({ gameData }) => {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#FFFFFF',
        padding: '1rem',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '1rem',
          lineHeight: '1.325rem',
          marginBottom: '0.25rem',
        }}
      >
        Apps
      </Typography>
      {gameData?.map((game: any) => (
        <Box
          sx={{
            // display: "flex",
            // flexDirection: "row",
            // gap: "1rem",
            display: 'grid',
            gridTemplateColumns: '1fr 3fr 2fr',
            gap: '1rem',
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: '0.75rem',
                lineHeight: '1rem',
                fontWeight: '600',
                color: '#6C6C6C',
                marginBottom: '0.25rem',
              }}
            >
              Game ID
            </Typography>
            <Typography
              sx={{
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                fontWeight: '700',
                letterSpacing: '-0.35px',
                color: '#162936',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {game?.gameId}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: '0.75rem',
                lineHeight: '1rem',
                fontWeight: '600',
                color: '#6C6C6C',
                marginBottom: '0.25rem',
              }}
            >
              Game Name
            </Typography>
            <Typography
              sx={{
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                fontWeight: '700',
                letterSpacing: '-0.35px',
                color: '#162936',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {game?.name}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: '0.75rem',
                lineHeight: '1rem',
                fontWeight: '600',
                color: '#6C6C6C',
                marginBottom: '0.25rem',
              }}
            >
              Deal Name
            </Typography>
            <Typography
              sx={{
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                fontWeight: '700',
                letterSpacing: '-0.35px',
                color: '#162936',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {game?.dealName}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default GamesDetailsCard;
